import { action, makeObservable, onBecomeObserved } from "mobx"

import { catchErrors, whitelistAddressesApi } from "@src/shared/api"
import { Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

type WhiteListCollectionLoadRequest = {
  page?: number
  pageSize?: number
}

export class WhiteListCollection extends loading(
  ["fetch"],
  CollectionWithPagination<any>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
    })

    const kill = onBecomeObserved(this, "isLoading", () => {
      kill()

      return this.load()
    })
  }

  async fetch(req: WhiteListCollectionLoadRequest = {}) {
    try {
      const { data: { data } = {} } =
        await whitelistAddressesApi.listWhitelistAddresses(
          undefined,
          req.page ?? 0,
          req.page ?? 25,
        )

      if (data) {
        const { addresses, pagination } = data as {
          addresses: any[]
          pagination: Pagination
        }

        return {
          data: addresses,
          pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }
}

export const GlobalWhiteListCollection =
  wrapSingleton<WhiteListCollection>(WhiteListCollection)
